/**
 * Date: 2021-01-13 14:18:52
 * description:
 *  @author zhizhan
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import "./index.less";
import React from "react";
import YxLink from "../YxLink";
import { Icon } from "antd";
import { get, yxStyleProps } from "../../../../utils";
import { YxComponent, Connection } from "../../../YxComponent";

/**
 * @param {any} iconfont 是否显示icon
 * return {*}
 */
const filterProps = (props) =>
  yxStyleProps(props, "iconfont", "text", "loading", "packUp");
const defaultProps = function () {
  return {
    type: "question",
    styleParam: {
      type: "default",
      size: "sm", // sm m l
    },
    disabled: false,
    selected: false,
    iconfont: null,
    text: null,
  };
};

@Connection(defaultProps)
class YxIcon extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      disabled: false,
      selected: false,
    };
    this.baseClassName = "yx_operation_icon_base";
  }

  get disabled() {
    const statusList = [
      get(this.props, ["disabled", "loading"], true),
      get(this.state, ["disabled", "loading"], true),
    ];
    return statusList.some((item) => item === true);
  }

  get className() {
    const classDict = {
      yx_yxIcon_: "styleParam.type",
      yx_yxIcon_size_: "styleParam.size",
    };
    const result = this.styleParamClassName(this.props, classDict);
    return result;
  }

  get param() {
    return {
      ...this.props,
      disabled: this.disabled,
      className: this.className,
      children: undefined,
    };
  }

  renderIcon = () => {
    const iconfont = get(this.props, "iconfont", null);
    if (iconfont === true) {
      const param = { ...this.param };
      const type = get(param, "type", "");
      const areaName = get(param, "areaName", "yx-iconfont");
      return (
        <i {...filterProps(param)}>
          <svg className={areaName} aria-hidden="true">
            <use xlinkHref={`#${type}`}></use>
          </svg>
        </i>
      );
    }
    return <Icon {...filterProps(this.param)}></Icon>;
  };

  render() {
    const text = get(this.props, "text", null);
    const packUp = get(this.props, "packUp", false);
    if (text != null && packUp === true) {
      return (
        <div className="yx_yxPopover_icon">
          {this.renderIcon()}
          <div className="icon_link">{text}</div>
        </div>
      );
    } else {
      return this.renderIcon();
    }
  }
}

export default YxIcon;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxAction/components/YxIcon/index.js